<template>
    <div class="filter-container rounded-lg mb-3">
      <h5 class="text-left mb-3 pl-3">Filters</h5>
      <div class="tags-container" v-if="selectedDevices.length || selectedTimeRange.value">
        <div v-for="device in selectedDevices" :key="device" class="tag">
          <span>{{ devices.find(d => d.value === device).label }}</span>
          <button @click="removeDevice(device)" class="remove-tag-btn">X</button>
        </div>
        <div v-if="selectedTimeRange.value" class="tag">
          <span>{{ timeRanges.find(r => r.value === selectedTimeRange.value).label }}</span>
          <button @click="removeTimeRange" class="remove-tag-btn">X</button>
        </div>
        <button @click="removeAllTags" class="remove-all-tags-btn">Cancel all</button>
      </div>
      <hr class="separator" />
      <div class="filter-menu">
        <h6 class="sub-title mb-2">Device</h6>
        <div v-for="device in devices" :key="device.value" class="checkbox-container">
          <input type="checkbox" :value="device.value" v-model="selectedDevices" @change="emitFiltersChange" />
          <label class="label-text">{{ device.label }}</label>
        </div>
      </div>
      <hr class="separator" />
      <div class="filter-menu mt-3">
        <h6 class="sub-title mb-2">Time Range</h6>
        <div v-for="range in timeRanges" :key="range.value" class="checkbox-container">
          <input type="radio" :value="range.value" v-model="selectedTimeRange.value" @change="emitFiltersChange" />
          <label class="label-text">{{ range.label }}</label>
        </div>
      </div>
      <hr class="separator" />
      <div class="filter-menu mt-3">
        <h6 class="sub-title mb-2">Tags</h6>
        <div class="tags-container-1 mb-3" v-if="selectedTags.size">
            <div v-for="tag in selectedTags" :key="tag" class="tag">
                <span>{{ tag }}</span>
                <button @click="removeSessionTag(tag)" class="remove-tag-btn ml-2">X</button>
            </div>
            <button @click="removeAllSessionsTags" class="remove-all-tags-btn">Cancel all</button>
        </div>
        <!-- Search bar design starts here -->
        <div class="search-container" ref="searchContainerRef">
          <input type="text" class="search-input" placeholder="Search tags..." v-model="searchText" @focus="showSuggestions = true" @keyup.enter="enterSessionTag">
          <i class="fa fa-search search-icon"></i>
          <!-- Suggestions dropdown -->
          <div v-if="showSuggestions && mostUsedsessionTags.size" class="suggestions-dropdown">
              <div v-for="tag in mostUsedsessionTags" :key="tag.id" @click="selectSessionTag(tag)">
                  {{ tag }}
               </div>
          </div>
        </div>
    </div>

    </div>
  </template>

<script>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import getMostUsedTags from '../../../composables/getMostUsedSessionTags'
export default {
  name: 'ChartFilterMenus',
  setup (props, context) {
    const selectedDevices = ref([])
    const selectedTimeRange = ref({ value: '' })
    const selectedTags = ref(new Set())
    const { mostUsedsessionTags, loadTags } = getMostUsedTags()
    const showSuggestions = ref(false)
    const searchText = ref('')

    onMounted(async () => {
      window.addEventListener('click', outsideClickListener)
      loadTags()
    })

    onBeforeUnmount(() => {
      window.removeEventListener('click', outsideClickListener)
    })

    const searchContainerRef = ref(null)

    const outsideClickListener = (event) => {
      if (!searchContainerRef.value.contains(event.target) && showSuggestions.value) {
        showSuggestions.value = false
      }
    }

    const devices = [
      { label: 'Knee Sleeve', value: 'Knee Brace' },
      { label: 'Glove', value: 'Glove' },
      { label: 'Pants', value: 'Pants' },
      { label: 'Band', value: 'Band' },
      { label: 'Neat', value: 'Neat' },
      { label: 'Test', value: 'Test' }
    ]

    const timeRanges = [
      { label: 'Last week', value: 'Last week' },
      { label: 'Last month', value: 'Last month' },
      { label: 'Last 6 months', value: 'Last 6 months' },
      { label: 'Last year', value: 'Last year' }
    ]

    const removeDevice = (device) => {
      selectedDevices.value = selectedDevices.value.filter(d => d !== device)
      emitFiltersChange()
    }

    const removeTimeRange = () => {
      selectedTimeRange.value = ''
      emitFiltersChange()
    }

    const removeAllTags = () => {
      selectedDevices.value = []
      selectedTimeRange.value = ''
      emitFiltersChange()
    }

    const emitFiltersChange = () => {
      context.emit('filtersChange', {
        devices: selectedDevices.value,
        timeRange: selectedTimeRange.value

      })
    }

    // session tags
    const removeAllSessionsTags = () => {
      selectedTags.value.clear()
      emitSessionsTagsChange()
    }

    const removeSessionTag = (tag) => {
      selectedTags.value.delete(tag)
      emitSessionsTagsChange()
    }
    const emitSessionsTagsChange = () => {
      context.emit('sessionsTagChange', selectedTags.value)
    }

    const enterSessionTag = () => {
      if (!searchText.value.trim()) {
        return
      }
      selectedTags.value.add(searchText.value)
      searchText.value = ''
      emitSessionsTagsChange()
    }

    const selectSessionTag = (tag) => {
      selectedTags.value.add(tag)
      showSuggestions.value = false
      emitSessionsTagsChange()
    }

    return {
      selectedDevices,
      selectedTimeRange,
      devices,
      timeRanges,
      removeDevice,
      removeTimeRange,
      removeAllTags,
      emitFiltersChange,
      mostUsedsessionTags,
      selectedTags,
      emitSessionsTagsChange,
      removeAllSessionsTags,
      removeSessionTag,
      showSuggestions,
      selectSessionTag,
      searchText,
      enterSessionTag,
      searchContainerRef
    }
  }
}
</script>
    <style scoped>
    .sub-title {
      font-size: 14px;
      font-weight: 500;
    }

    .filter-container {
      background-color: white;
      font-size: 0.8rem;
      border-radius: 15px;
      width: 100%;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .filter-menu {
      padding: 0 15px;
    }

    .separator {
      border-top: 1px dotted lightgrey;
    }

    .checkbox-container {
      display: flex;
      align-items: baseline;
    }

    .label-text {
      margin-left: 5px;
    }

    .date-container {
      display: flex;
      align-items: center;
    }

    .date-range {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }

    .sub-date-label {
      width: 80px;
      margin-left: 17px;
    }

    .text-left {
      text-align: left;
    }

    .tags-container {
      display: flex;
      flex-wrap: wrap;
      padding-left: 15px;
    }

    .tags-container-1 {
      display: flex;
      flex-wrap: wrap;
    }

    .tag {
      background-color: var(--light-grey);
      padding: 5px 10px;
      margin: 3px;
      border-radius: 5px;
      display: flex;
      align-items: center;
    }

    .remove-tag-btn {
      background-color: transparent;
      border: none;
      color: red;
      cursor: pointer;
      margin-left: 5px;
    }

    .remove-all-tags-btn {
    background-color: transparent;
    border: none;
    cursor: pointer;
    margin: 5px;
    color: grey;
    font-size: 12px;
  }

  .filter-container {
    margin-top: 0 !important;
  }

.filter-menu {
    font-family: Arial, sans-serif;
    position: relative;
}

.search-container {
    position: relative;
    margin-bottom: 10px;
    font-family: Arial, sans-serif;
}

.search-input {
    width: 100%;
    padding: 8px;
    padding-right: 30px;
    border: 1px solid #ccc;
    border-radius: 8px;
    font-size: 0.8rem;
    outline: none;
    transition: border-color 0.3s;
}

.search-input:focus {
    border-color: #b47af3;
}

.search-icon {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-50%);
    color: #888;
    cursor: pointer;
}

.suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 150px;
    overflow-y: auto;
    background-color: var(--container-color);
    border: 1px solid var(--border-color);
    border-top: none;
    border-radius: 0 0 8px 8px;
    z-index: 10;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.05);
}

.suggestions-dropdown div {
    padding: 8px;
    font-size: 0.8rem;
    color: var(--muted-text-color);
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
}

.suggestions-dropdown div:hover {
    background-color: var(--light-grey);
}

    </style>
